import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    public ngOnInit() {
        window.location.replace('/specialization-distribution');
    }
}

export default PageAccessComponent;